import { useMutation } from 'react-query';

import Api from '../../api/api';

export type ConvertCategoryToSubCategoryDTO = {
  category?: { id: string } | null;
};

export const convertCategoryToSubCategory = async (categoryId: string, params: ConvertCategoryToSubCategoryDTO) => {
  const [response, bodyOrError] = await Api.patch(`categories/${categoryId}/convert-to-sub-category`, params);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useConvertCategoryToSubCategory = () => {
  return useMutation('convertCategoryToSubCategory', (data: { categoryId: string; params: ConvertCategoryToSubCategoryDTO }) => {
    return convertCategoryToSubCategory(data.categoryId, data.params);
  });
};
